import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { Router } from '@angular/router';
import { TareasApiService } from '../../../../service/api/tareas-api.service';
import { Utils } from '../../../../common/utils';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { Filtering } from '../../../../service/filtering/filtering';
import { BaseView } from '../../../base-view';
import moment from 'moment';
import { TreeNode } from 'primeng/api';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { PlanAbonadoEnvironmentDefinition } from './environment-variables';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { createCsv } from 'src/app/common/components/reactive-form-builder/export/createCsv';
import { PlanAbonadoFormDefinition } from './plan-abonado-form/form-control/form-definition';
import { PlanAbonadoModel } from 'src/app/models/tareas/plan-abonado.model';

moment.locale('es');
@Component({
    selector: 'app-plan-abonado',
    standalone: false,
    templateUrl: './plan-abonado.component.html',
    styleUrls: ['./plan-abonado.component.scss']
})
export class PlanAbonadoComponent extends BaseView<PlanAbonadoModel> implements OnInit, OnDestroy {
    public years = [
        { label: '...', value: 0 },
    ];

    public form: PlanAbonadoFormDefinition | null = null;

    public env: PlanAbonadoEnvironmentDefinition = new PlanAbonadoEnvironmentDefinition();

    public hiddenButtonDelete = false;

    public showButtonDuplicate = true;

    public filter: Filtering<PlanAbonadoModel> = new Filtering<PlanAbonadoModel>();

    public getRequest: RequestHandler<PlanAbonadoModel[]> = this.tareasApi.planAbonado.GET;

    public deleteRequest: RequestHandler<PlanAbonadoModel> = this.tareasApi.planAbonado.DELETE;

    public pathToForm = 'crear-plan-abonado';

    public menuItemId = 'plan-abonado';

    public btnAnadir = 'Añadir Plan de Abonado';

    public override canShow: Record<string, boolean> = {};

    public override model: PlanAbonadoModel = {};

    public cols: ColInterface[] = [

        {
            field: 'cliente_nombre',
            header: this.env.clienteName,
            filter: '',
            visible: this.env.hasClients && this.env.userCanSeeClientes && !this.env.showTareasMto
        },
        {
            field: 'programa_calculo',
            header: 'Programa Cálculo'
        },
        {
            field: 'necesidad_uf_n',
            header: 'Necesidad UF N (Kg/Ha)',
        },
        {
            field: 'necesidad_uf_p205',
            header: 'Necesidad UF P205 (Kg/Ha)',
        },
        {
            field: 'necesidad_uf_k20',
            header: 'Necesidad UF K20 (Kg/Ha)',
        },
        {
            field: 'objetivo_produccion',
            header: 'Objetivo Producción (Kg/Ha)'
        },
        {
            field: 'cultivo',
            header: 'Cultivo',
        },
        {
            field: 'uso_herramienta',
            header: 'Uso de Herramienta',
        },
        {
            field: 'codigo_regfer',
            header: 'Código REGFER',
        },
        {
            field: 'fecha_asesoramiento',
            header: 'Fecha Elaboración Plan Abonado',
        },
    ];

    constructor(
        public tareasApi: TareasApiService,
        private readonly dashboardEvents: DashboardService,
        public dashboard: DashboardService,
        private readonly router: Router
    ) {
        super(dashboardEvents, tareasApi.planAbonado.GET);
    }

    ngOnInit(): void {
        this.dashboardEvents.setSubmenuItem('tareas', 'plan-abonado');
    }

    public globalConditionalStyle(_value: string, _col: ColInterface): ColStylesInterface {
        return { textAlign: 'center' };
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<PlanAbonadoModel>): string {
        const planAbonado = row.data as PlanAbonadoModel;

        if (col.field === 'uso_herramienta') {
            return planAbonado.uso_herramienta === 1 ? 'Sí' : 'No'
        }
        return value;
    }

    public add(): void {
        this.router.navigate(['dashboard', this.pathToForm]);
    }

    public edit(data: PlanAbonadoModel): void {
        this.router.navigate(['dashboard', 'editar-plan-abonado', data.id]);
    }

    public duplicate(data: PlanAbonadoModel): void {
        this.router.navigate(['dashboard', 'duplicar-plan-abonado', data.id]);
    }


    public override show(modal: string, data: PlanAbonadoModel): void {
        this.model = data;

        super.show(modal, this.model);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

        this.form = new PlanAbonadoFormDefinition(formType, data as Record<string, string>, null);
    }

    public override hide(modal: string): void {
        this.model = {};
        this.canShow[modal] = false;
    }

    public override ngOnDestroy(): void {
        Utils.unsuscribe([
            this.tareasApi.planAbonado.GET
        ]);
    }

    public downloadCsv(): void {
        this.form = new PlanAbonadoFormDefinition(
            +FormType.EXPORT,
            this.filtering.value as unknown as Record<string, string>,
            null
        );
        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, this.filtering.value as PlanAbonadoModel[]);
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;

        csvLink.download = this.form.formFields.name + '.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();
    }
}
